import { AudioPlayer, type AudioPlayerLike } from '@orborix/voice-client';
import { isAudioStuck } from './audioStuck.js';

/**
 * Reproductor que no reproduce: lo usa la sesión cuando el audio del sistema
 * no responde (ver `audioStuck.ts`). No crea ningún `AudioContext` (crearlo es
 * lo que congelaba la pestaña), descarta el audio que llegue y nunca está
 * «sonando», así el texto del coach se muestra y se cierra en el `turn-end`.
 */
export class SilentPlayer implements AudioPlayerLike {
  unlock(): Promise<void> {
    return Promise.resolve();
  }
  push(): void {
    /* sin salida de audio */
  }
  reset(): void {
    /* nada que cortar */
  }
  destroy(): Promise<void> {
    return Promise.resolve();
  }
  getClockMs(): number {
    return performance.now();
  }
  awaitIdle(): Promise<void> {
    return Promise.resolve();
  }
  isPlaying(): boolean {
    return false;
  }
  getOutputRms(): number {
    return 0;
  }
  markTurnStart(): void {}
  closeTurnAccounting(): void {}
  getTurnPlayback(): { playedMs: number; receivedMs: number } {
    return { playedMs: 0, receivedMs: 0 };
  }
}

/**
 * Fábrica del reproductor de la sesión de voz: el de siempre, salvo que el
 * audio del sistema esté trabado. Se decide al abrir la sesión.
 */
export function speakPlayerFactory(): AudioPlayerLike {
  return isAudioStuck() ? new SilentPlayer() : new AudioPlayer();
}
